import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectAggregatorsStatus } from './selectors';
import { AGGREGATORS_KEY } from '../lib/constants';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Network, Thunk } from '../types';

const INITIAL_AGGREGATOR_STATE = {
  name: '',
  id: '',
};

function useDoingBusinessAsName(network: Network) {
  if (network.doingBusinessAs) {
    network.name = network.doingBusinessAs;
  }

  return network;
}

export const loadAggregators = (): Thunk => async (dispatch, getState, { request }) => {
  const KEY = 'aggregators';
  const endpoint = `${PODCASTERS_SERVICE}/v0/feeds/aggregators`;

  /* istanbul ignore next */
  if (selectAggregatorsStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'submissions/LOAD_AGGREGATORS_REQUEST'));

  try {
    const data: {
      networks: Network[];
    } = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: data.networks.map(useDoingBusinessAsName) }), unsetStatus([KEY])],
        'submission/LOAD_AGGREGATORS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [KEY]: ERROR }, 'submission/LOAD_AGGREGATORS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const initializeAggregator = (): Thunk => dispatch => {
  dispatch(
    setData({ [AGGREGATORS_KEY]: INITIAL_AGGREGATOR_STATE }, 'submission/INITIALIZE_AGGREGATOR'),
  );
};

export const setAggregator = (aggregator: Network): Thunk => dispatch => {
  dispatch(setData({ [AGGREGATORS_KEY]: aggregator }, 'submission/SET_AGGREGATOR'));
};
